import React, { useEffect, useState } from 'react'
import { NewsInterface, DefaultNewsInterface, ShowNewsContext, modalType } from './types';
import { useDispatch } from 'react-redux';
import { getNewsApi } from '../../redux/news/newsApiCalls';
import DataNews from './DataNews';
import AddNewsModal from './AddNewModal';
import { FaChevronCircleLeft, FaPlus } from 'react-icons/fa';
import { useNavigate } from 'react-router';
import SuccessMsg from '../../Messages/SuccessMsg';
import EditNewsModal from './EditNewModal';
import DeleteNewsModal from './DeleteNewModal';
import DeletePhotoNews from './photos/DeletePhotoNew';

const ShowNews:React.FC = () => {
  const [showSuccessMsg, setShowSuccessMsg] = useState(false);
  const [showAddNewsModal, setShowAddNewsModal] = useState(false);
  const [showEditNewsModal, setShowEditNewsModal] = useState(false);
  const [showDeleteNewsModal, setShowDeleteNewsModal] = useState(false);
  const [selectedNews, setSelectedNews] = useState<NewsInterface>(DefaultNewsInterface)
  const [selectedModal, setSelectedModal] = useState("")
  const [showDeleteNewsPhotoModal, setShowDeleteNewsPhotoModal] = useState(false);
  const [selectedPhoto, setSelectedPhoto] = useState("")

  const dispatch: any = useDispatch()

  useEffect(() => {
    const fetchAPIs = async () => {
      await dispatch(getNewsApi())
    }
    fetchAPIs()
  }, [dispatch])

  const navigate = useNavigate()

  return (
    <ShowNewsContext.Provider value={{ 
      showSuccessMsg, setShowSuccessMsg,
      showAddNewsModal, setShowAddNewsModal,
      showEditNewsModal, setShowEditNewsModal,
      showDeleteNewsModal, setShowDeleteNewsModal,
      selectedNews, setSelectedNews,
      selectedModal, setSelectedModal,
      showDeleteNewsPhotoModal, setShowDeleteNewsPhotoModal,
      selectedPhoto, setSelectedPhoto,
    }}> 
      <SuccessMsg modal={showSuccessMsg} toggle={() => setShowSuccessMsg(!showSuccessMsg)}/>
      <div className="flex justify-start gap-2">
        <FaChevronCircleLeft style={{ fontSize: "30px" }} className="text-main" onClick={() => navigate("/")}/>
        <button className="p-2 rounded bg-main text-white" onClick={() => {
            setSelectedModal(modalType.AddModal)
            setShowAddNewsModal(!showAddNewsModal)
          }}>
          <FaPlus />
        </button>
      </div>
      <AddNewsModal modal={showAddNewsModal} toggle={() => setShowAddNewsModal(!showAddNewsModal)} />
      {selectedNews?.title && 
        <EditNewsModal modal={showEditNewsModal} toggle={() => setShowEditNewsModal(!showEditNewsModal)} />
      }
      {selectedNews?.title && 
        <DeleteNewsModal modal={showDeleteNewsModal} toggle={() => setShowDeleteNewsModal(!showDeleteNewsModal)} />
      }
      <DataNews />
      {
        showDeleteNewsPhotoModal && 
        <DeletePhotoNews modal={showDeleteNewsPhotoModal}  toggle={() => setShowDeleteNewsPhotoModal(!showDeleteNewsPhotoModal)}/>
      }

    </ShowNewsContext.Provider>
  )
}

export default ShowNews

